// extracted by mini-css-extract-plugin
module.exports = {"container":"Paginacion_container__3zDYR","btnLeft":"Paginacion_btnLeft__1zoDi","btnRight":"Paginacion_btnRight__11_al"};